var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUthermHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22",
    "data-name": "Group 22",
    xmlns: "http://www.w3.org/2000/svg",
    width: 157.459,
    height: 79.218,
    viewBox: "0 0 157.459 79.218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M2.069-2.14c.634,0,.666-.91,1.194,3.495S4.18,15.48,4.18,15.48V49.694A2.44,2.44,0,0,1,1.662,52C.744,52,0,50.657,0,49V15.48S.209,5.759.726,1.354,1.435-2.14,2.069-2.14Z",
    transform: "translate(9.729 2.218)",
    fill: "#868686"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect43",
    width: 157.459,
    height: 57.947,
    rx: 4.806,
    transform: "translate(0 21.271)",
    fill: "#efefef"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 147,
    height: 48,
    rx: 4,
    transform: "translate(5.729 26.218)",
    fill: "#fafafa"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471",
    width: 11.131,
    height: 11.674,
    rx: 1.44,
    transform: "translate(27.637 30.072)",
    fill: "#4070aa"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-2",
    width: 1.148,
    height: 6.839,
    rx: 0.574,
    transform: "translate(13.91 32.391)",
    fill: "#134e96"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-2-4",
    width: 1.148,
    height: 6.839,
    rx: 0.574,
    transform: "translate(16.116 32.391)",
    fill: "#9f9f9f"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-2-4-5",
    width: 1.148,
    height: 6.839,
    rx: 0.574,
    transform: "translate(18.282 32.588)",
    fill: "#134e96"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-2-4-5-7",
    width: 1.148,
    height: 6.839,
    rx: 0.574,
    transform: "translate(20.352 32.588)",
    fill: "#9f9f9f"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-0",
    width: 11.131,
    height: 11.674,
    rx: 1.44,
    transform: "translate(119.691 30.703)",
    fill: "#4070aa"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-8",
    width: 55.74,
    height: 11.674,
    rx: 5.565,
    transform: "translate(50.897 30.703)",
    fill: "#134e96"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUthermHover);
export default __webpack_public_path__ + "static/media/utherm-hover.33bc23aaa59cb28758d7f8763a5ed5cc.svg";
export { ForwardRef as ReactComponent };